import whenDomReady from 'when-dom-ready';
import debugWidget from "./widget-debug.js";

export default class {
  constructor(permalink, source, rootURL, uuid) {
    this.permalink = permalink;
    this.source = source;
    this.rootURL = rootURL;
    this.trackerURL = `${this.rootURL}api/v1/stats/track`;

    this.DEBUG = function(output) {
      debugWidget(output, uuid, this);
    }
  }

  trackShopableClick(url, photoID, shopableID) {
    return this.track({
      type: "outbound",
      permalink: this.permalink,
      photo_id: photoID,
      url,
      source: this.source,
      shopable_id: shopableID
    });
  }

  trackModalView(photoID) {
    return this.track({
      type: "modal-view",
      permalink: this.permalink,
      photo_id: photoID,
      source: this.source
    });
  }

  trackPageView() {}
  // noop for now as this has
  // potential to cause way too much
  // traffic

  track(data) {
    const promise = new Promise((resolve, reject) => {

      const timeoutID = setTimeout(function() {
        this.DEBUG("resolving trackShoppableClick in timeout");
        return resolve();
      } , 1000);

      let url = new URL(this.trackerURL);
      for (const option in data) {
        url.searchParams.set(option, data[option]);
      }

      fetch(url)
        .then((response) => {
          window.clearTimeout(timeoutID);
          return resolve();
        });

    });

    return promise;
  }
}
